import { useRef } from "react";
import React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import { EditorSyncFiles } from "../EditorSync";
import { CueSheet } from "../types/editor";
import EditorPlayerBuffer from "./EditorPlayerBuffer";

interface Props {
  sheet: CueSheet;
  files: EditorSyncFiles;
}

export const EditorPlayerController = ({ sheet, files }: Props) => {
  const factory = (child: React.ReactElement): React.ReactElement => {
    const node = React.cloneElement(child, {
      current: sheet.current || 0,
    });
    return node;
  };

  const pRef = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      nodeRef={pRef}
      in={!sheet.blackout}
      timeout={1000}
      classNames="opacity-controller-blackout"
    >
      <div
        className="position-absolute top-0 left-0 w-100 h-100"
        style={{ overflow: "hidden" }}
        ref={pRef}
      >
        <TransitionGroup childFactory={factory}>
          {[
            <CSSTransition
              key={sheet.current || 0}
              timeout={2000}
              classNames={{
                enter: "lite-enter",
                enterActive: "lite-enter-active",
                exit: "lite-exit",
                exitActive: "lite-exit-active",
              }}
            >
              <div className="position-absolute top-0 left-0 w-100 h-100">
                <EditorPlayerBuffer
                  files={files}
                  item={sheet.items[sheet.current || 0]}
                />
              </div>
            </CSSTransition>,
          ]}
        </TransitionGroup>
      </div>
    </CSSTransition>
  );
};

export default EditorPlayerController;
